import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'translation'

import PlayerDurationSlider from './PlayerDurationSlider'
import PlayerPlaylistNextSong from './PlayerPlaylistNextSong'

import { secToTime } from 'utils/conversion'
import Spinner from 'components/ui/Spinner/Spinner'
import PlayerProgressBar from './PlayerProgressBar.js'
import PlayIcon from 'assets/play_blue.png'
import PauseIcon from 'assets/pause_blue.png'
import PlayIcon2 from 'assets/play.png'
import PauseIcon2 from 'assets/pause.png'
import { isBefore } from 'date-fns'
import { connect } from 'react-redux'
import { SLEEP, AWAKENING } from 'utils/constants'

const PlayerControl = ({
  attachPlayPauseBtnRef,
  canPlay,
  playing,
  playTimeCurrent,
  songInfo,
  content,
  totalTimeDuration,
  downloadProgress,
  isDownloading,
  downloadId,
  currentSongRemainingSec,
  selectedDuration,
  changeDurationHandler,
  initialDuration,
  isPlayingPlaylist,
  indicationType,
  disableDurationSlider,
}) => {
  const showDownloadPercent = !canPlay && isDownloading && songInfo.songId === downloadId
  const min = indicationType === SLEEP || indicationType === AWAKENING ? 15 : 20

  return (
    <div className="section_in space-evenly_content_mod relative_mod row_mod">
      <div className="player_main">
        <div className="player_main_in">
          <div className="player_cover_img_w">
            <img
              className="player_cover_img"
              src={songInfo.imageUrl}
              alt={`${songInfo.title}, ${t('player.BY')} ${songInfo.artist}`}
            />
            {songInfo.newUntil && isBefore(new Date(), new Date(songInfo.newUntil)) ? (
              <div className="player_cover_new_until">{t('genre.NEW')}</div>
            ) : null}
          </div>
          <div className="player_artist_w">
            {/* {canPlay && <div className="player_genre">{songInfo.genreName}</div>} */}
            {window.innerWidth >= 973 && canPlay && (
              <div className="player_song">{songInfo.title}</div>
            )}
            {window.innerWidth < 973 && (
              <button
                className={`player_song_wrap ${canPlay ? 'can_play' : ''}`}
                ref={attachPlayPauseBtnRef}
              >
                <div className="player_song">
                  {playing ? (
                    <div className="player_btn pause_mod">
                      <img className="player_btn_img" src={PauseIcon2} alt="pause" />
                    </div>
                  ) : (
                    <div className="player_btn">
                      <img className="player_btn_img" src={PlayIcon2} alt="play" />
                    </div>
                  )}
                  {songInfo.title}
                </div>
              </button>
            )}
            {/* {canPlay && <div className="player_song">{songInfo.title}</div>} */}
            {canPlay && <div className="player_artist">{songInfo.artist}</div>}
            {isPlayingPlaylist ? (
              <PlayerPlaylistNextSong currentSongRemainingSec={currentSongRemainingSec} />
            ) : (
              <PlayerDurationSlider
                selectedDuration={selectedDuration}
                changeDurationHandler={changeDurationHandler}
                initialValue={initialDuration}
                min={min}
                max={90}
                disabled={disableDurationSlider}
              />
            )}
            {window.innerWidth >= 973 && (
              <button
                className={`player_song_wrap ${canPlay ? 'can_play' : ''}`}
                ref={attachPlayPauseBtnRef}
              >
                {canPlay ? (
                  playing ? (
                    <div className="player_btn_wrap">
                      <div className="player_btn pause_mod">
                        <img className="player_btn_img" src={PauseIcon} alt="pause" />
                      </div>
                      <div className="player_btn_title">Pause</div>
                    </div>
                  ) : (
                    <div className="player_btn_wrap">
                      <div className="player_btn">
                        <img className="player_btn_img" src={PlayIcon} alt="play" />
                      </div>
                      <div className="player_btn_title">Play</div>
                    </div>
                  )
                ) : (
                  <Spinner
                    style={{
                      ...(showDownloadPercent
                        ? { marginTop: '12rem' }
                        : { paddingTop: '8em' }),
                    }}
                  >
                    {showDownloadPercent && (
                      <div className="popup_downloading_display_group is_downloading">
                        <div className="popup_downloading_display_text">
                          <span className="popup_downloading_display_text_bold">
                            {downloadProgress}%
                          </span>
                        </div>
                      </div>
                    )}
                  </Spinner>
                )}
              </button>
            )}
          </div>
        </div>
        <div className="player_description desktop_mod">
          <div className="player_description_title">{t('player.DESCRIPTION')}:</div>
          <div className="player_description_text">
            {content.description[0].description}
          </div>
        </div>
      </div>
      <div className="player_time_progress_wrap">
        <PlayerProgressBar
          playTimeCurrent={playTimeCurrent}
          totalTimeDuration={totalTimeDuration}
        />
        <div
          className={`player_song_time ${
            totalTimeDuration ? '' : 'player_song_time_hidden_'
          }`}
        >
          {totalTimeDuration && (
            <>
              <div className="player_song_current">
                {secToTime(totalTimeDuration - playTimeCurrent, 'mm:ss')}
              </div>
              <div className="player_song_current_info">
                {t(`indication.${indicationType.toUpperCase()}`)}
              </div>
            </>
          )}
        </div>
      </div>
      {/* <div className="player_description mobile_mod">
        <div className="player_description_title">{t('player.DESCRIPTION')}:</div>
        <div className="player_description_text">
          {content.description[0].description}
        </div>
      </div> */}
    </div>
  )
}

const mapStateToProps = ({
  player: { indicationType },
  download: { downloadId, downloadProgress, isDownloading },
}) => ({
  downloadId,
  downloadProgress,
  isDownloading,
  indicationType,
})

export default connect(mapStateToProps)(PlayerControl)

PlayerControl.propTypes = {
  attachPlayPauseBtnRef: PropTypes.func.isRequired,
  playing: PropTypes.bool,
  playTimeCurrent: PropTypes.number,
  songInfo: PropTypes.object.isRequired,
  totalTimeDuration: PropTypes.number,
  canPlay: PropTypes.bool.isRequired,
  newUntil: PropTypes.string,
  downloadProgress: PropTypes.number.isRequired,
  isDownloading: PropTypes.bool.isRequired,
}
